module.exports = __webpack_public_path__ + "img/wenshang3.a6dc9ae0.png";